import { theme } from "../theme";

export const EmployeeTableStyles = () => ({
  emptyTableCell: {
    width: "4%",
  },
  button: {
    width: '100%',
    maxHeight: '64px',
    height: '56px',
    fontSize: '1.2rem',
    textTransform: 'none',
    backgroundColor: theme.palette.primary.black,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.black,
      boxShadow: theme.button.boxShadowBtn,
    },
    '& .MuiButton-endIcon>*:nth-of-type(1)': {
      fontSize: '1.6rem',
    },
  },
  checkbox: {
    color: theme.palette.primary.black,
    "&.MuiCheckbox-root": {
      color: theme.palette.primary.black,
    },
  },
  tableContainer: {
    minHeight: "700px",
    maxHeight: "800px",
    boxSizing: 'border-box !important',
    "::-webkit-scrollbar": {
      width: "10px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "rgba(16, 16, 16, 0.5)",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
  tableToolbar: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    padding: "32px 28px",
    borderBottom: "1px solid rgba(224,224,224,1)",
  },
  toolbarCtn: {
    alignItems: "center",
    display: "flex",
    gap: 3,
  },
  downloadLink: {
    textDecoration: "none",
    "& .MuiButton-root": {
      color: theme.palette.primary.black,
      border: `1px solid ${theme.palette.primary.black}`,
      textTransform: "none",
      "&:hover": {
        backgroundColor: theme.palette.primary.white,
        boxShadow: 3,
      },
    },
  },
  exportLink: {
    textDecoration: "none",
  },
  tableHead: {
    height: "90px",
  },
  tableRow: {
    height: "90px",
  },
  tableColumnHide: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  bottomBorder: {
    borderBottom: "1px solid rgba(224,224,224,1)",
  },
  borderNone: {
    border: "none",
  },
  tableHeadTitle: {
    textAlign: "center !important",
    fontSize: "1.3rem",
    fontWeight: 700,
    lineHeight: "1.2",
    color: theme.palette.primary.black,
    "&:hover": {
      color: theme.palette.primary.black,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.1rem"
    },
  },
  tableHeadMax: {
    maxWidth: "300px",
  },
  loadCell: {
    width: "30%",
  },
  tableCell: {
    fontSize: "1.2rem",
    textAlign: 'center',
    lineHeight: "1.2",
    color: theme.palette.secondary.black,
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem"
    },
  },
  tableCellCompany: {
    fontSize: "1.2rem",
    flex: 1,
    cursor: 'pointer',
    color: theme.palette.secondary.black,
    "&:hover": {
      textDecoration: 'underline'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem"
    },
  },
  qStatusBox: {
    "&::first-letter": {
      textTransform: "capitalize",
    },
    border: `1px solid ${theme.palette.primary.black}`,  
    width: "100%",
    height: "50px",
    fontSize: "1.3rem",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  moreButton: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    width: "100%",
    variant: "outlined",
    color: theme.palette.primary.black,
    textTransform: "none",
    fontSize: "1rem",
    textDecoration: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  searchInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      position: "relative",
      color: theme.palette.secondary.black,
      "& .MuiInputAdornment-root": {
        color: theme.palette.primary.black,
      },
    },
  },
  dialog: {
    maxWidth: "sm",
    title: {
      fontSize: "2rem",
      fontWeight: "700",
      color: theme.palette.primary.black,
    },
    content: {
      fontSize: "1.5rem",
      color: theme.palette.secondary.black,
    },
    dialogBox: {
      "& .MuiDialog-paper": {
        padding: "48px",
      },
    },
    cancelButton: "rgba(36, 35, 35, 0.5)",
    ctaButton: theme.palette.primary.black,
    showButton: "none",
  },
  wrapperBackHome: {
    textAlign: 'center',
    padding: '20px 0px',
  },
  tableCellLastModified: {
    fontSize: "1.2rem",
    flex: 1,
    color: theme.palette.secondary.black,
  },
  wrapperTable: {
    minHeight: '965px',
    width: '100%',
    backgroundColor: theme.palette.primary.white,
  },
  tableGrid: {
    minHeight: '965px !important',
    borderRadius: '4px',
    width: '100%',
    fontSize: "1em",
    [theme.breakpoints.down('md')]: {
      minHeight: '1565px !important',
    },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeadersInner': {
      fontSize: "1.5rem",
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '0',
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: '700',
        paddingLeft: '12px',
        textAlign: "center !important",
        fontSize: "1.5rem",
      },
    },
    '& .MuiDataGrid-row': {
      fontSize: "15px",
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
      },
    },
    '& .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
    },
    '& 	.MuiDataGrid-checkboxInput': {
      '& .MuiSvgIcon-root': {
        fontSize: "1.5rem",
        [theme.breakpoints.down('md')]: {
          fontSize: '16px',
        },
      },
    },
  },
  titleModal:{
    margin: 0,
    display: 'flex',
    fontSize: '20px',
    fontWeight: '600'
  },
  containerCheck: {
    display: 'flex',
    gap: 0,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
  },
  iconButton: {
    color: theme.palette.secondary.black,
    "&:hover": {
      backgroundColor: theme.cards.iconBackground
    },
  },
  checkboxDefault: {
    '& .MuiSvgIcon-root': {
      fontSize: 30
    }
  },
});

export const EmployeeDetailStyles = () => ({
  employeeDetails: {
    marginTop: "15px",
    width: '100%'
  },
  employeeDetailTitleBox:{
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: { xl: "0px", lg: "0px", md: "0px", sm: "0px", xs: "20px" },
  },
  employeeDetailTypographicBox:{
    margin: 0,
    lineHeight: '15px',
    color: theme.palette.primary.black,
  },
  personalInformationText: {
    fontSize: "0.875rem",
    fontWeight: 700,
    textAlign: "start",
    margin: "0px 0px 10px 0px",
    width: "100%",
    color: theme.palette.primary.black,
  },
  textUnsubscribe: {
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
    color: theme.palette.primary.white,
    backgroundColor: theme.palette.primary.main,
    height: '25px',
    borderRadius: '4px',
    padding: '0px 10px',
    marginBottom: '20px',
    textTransform: "capitalize",
  },
  detailFields: {
    "& > div": {
      "& .MuiInputLabel-shrink": {
        padding: "0 8px",
        background: theme.palette.primary.white,
        color: theme.palette.primary.main,
        fontSize: "20px",
      },
      "& .MuiFormHelperText-root": {
        background: theme.palette.primary.white,
      },
    },
  },
  detailRows: {
    "& > div": {
      height: "55px",
      width: "23%",
      "& .MuiOutlinedInput-root": {
        height: "100%",
        "& .MuiOutlinedInput-input": {
          padding: "0 24px",
        },
        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
            borderWidth: "2px",
          },
        },
      },
      "& .MuiInputLabel-root": {
        top: "-30px",
        left: "10px",
        transform: "translate(0px, 5px)",
      },
      "& .MuiInputLabel-shrink": {
        padding: "0 8px",
        background: theme.palette.primary.white,
        color: theme.palette.primary.main,
        top: "-30px",
        left: "0px",
        transform: "translate(15px, 20px)",
      },
      "& span": { display: "none" },
      "& .MuiFormHelperText-root": {
        position: "absolute",
        bottom: "-10px",
        left: "10px",
        background: theme.palette.primary.white,
        padding: "0 10px",
        fontSize: "0.875rem",
        margin: "0",
      },
    },
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "30px",
  },
  linkBox: {
    "& p": {
      fontSize: "1.125rem",
      marginRight: "16px",
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  linkText: {
    width: "60%",
  },
  sendButton: {
    height: "50px",
    width: "15%",
    background: theme.palette.primary.main,
    color: theme.palette.primary.white,
    fontSize: "1rem",
    "&:hover": {
      background: theme.palette.primary.main,
      boxShadow: 4,
    },
  },
  saveChangesBtn: {
    textTransform: "none",
    width: "60%",
    height: "58px",
    fontSize: "1.125rem",
    background: theme.palette.primary.black,
    color: theme.palette.primary.white,
    margin: "48px 0",
    "&:hover": {
      background: theme.palette.primary.black,
      boxShadow: 3,
    },
  },
  select: {
    width: "100%",
    "& .MuiOutlinedInput-input": {
      padding: "16px 20px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.primary.black}`,
    },
  },
  selectError: {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.error.mediumError}`,
      "&:hover": {
        border: `1px solid ${theme.palette.error.mediumError}`,
      },
    },
  },
  dialog: {
    maxWidth: "sm",
    title: {
      fontSize: "2rem",
      fontWeight: "700",
      color: theme.palette.primary.black,
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5rem",
      },
    },
    content: {
      fontSize: "1.5rem",
      color: theme.palette.primary.black,
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.125rem",
      },
    },
    dialogBox: {
      "& .MuiDialog-paper": {
        padding: "48px",
        [theme.breakpoints.down("sm")]: {
          padding: "24px",
        },
      },
    },
    cancelButton: "rgba(36, 35, 35, 0.5)",
    ctaButton: theme.palette.primary.black,
    showButton: "none",
  },
  downloadButton: {
    height: "50px",
    width: "15%",
    background: 'trasparent',
    color: theme.palette.secondary.black,
    border: `1px solid ${theme.palette.secondary.mediumGray}`,
    fontSize: "1.125rem",
    textTransform: 'none',
    "&:hover": {
      background: theme.palette.primary.main,
      boxShadow: 4,
      border: 'none',
      color: theme.palette.primary.white,
    },
  },
  typography: {
    display: 'flex',
    alignItems: 'start',
    fontSize: '1.2rem',
    width: '100%',
    padding: '25px 0px',
    color: theme.palette.secondary.black,
  },
  box: {
    minHeight: '30px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.cards.bgCards,
    boxSizing: 'border-box',
    color: theme.palette.primary.black,
    width: '100%',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    position: 'relative',
    overflow: 'hidden'
  },
  boxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    background: theme.cards.bgCards,
    boxSizing: 'border-box',
    flexDirection: 'column',
    gap: '5px',
  },
  cardProgress: {
    backgroundColor: theme.palette.primary.white,
    borderRadius: '8px',
    padding: '15px',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
    background: theme.cards.bgCards,
    width: '100%',
  },
  cardProgressContainerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px' 
  },
  cardProgressIcon: {
    color: theme.palette.primary.main,
    fontSize: '24px' 
  },
  cardLinearProgress: {
    height: '8px',
    borderRadius: '4px',
    backgroundColor: theme.palette.secondary.mediumGray,
    '& .MuiLinearProgress-bar': {
        borderRadius: '4px',
        backgroundColor: theme.palette.primary.black,
    },
  },
  cardProgressPending: {
    fontSize: '13px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    color: theme.palette.secondary.mainGray,
    margin: 0,
  },
});

export const QuestionnaireResultsStyles = () => ({
  mainBox: {
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& h1": {
      fontSize: "2.5rem",
      margin: "15px 0",
      fontWeight: 700,
      textAlign: "center",
    },
    "& h3": {
      fontSize: "1.3rem",
      marginBottom: "30px",
      textAlign: "center",
    },
  },
  subBox: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.primary.white,
    padding: "40px 5vw",
    position: "relative",
    width: { xl: "80%", md: "80%", sm: "80%", xs: "95%" },
    boxShadow: "0px 6px 8px 4px rgb(36 35 35 / 15%)",
    borderRadius: "4px",
  },
  buttonLinkGoBack: {
    marginRight: "auto",
    textDecoration: "none",
  },
  buttonLinkEdit: {
    marginLeft: "auto",
    textDecoration: "none",
  },
  qaBox: {
    paddingLeft: "1em",
    "& .MuiBox-root": {
      padding: "0.5em 1em",
    },
  },
});

export const UserManagementStyle = () => ({
  container: {
    width: '100%',
    minHeight: '100vh',
    padding: "50px",
    [theme.breakpoints.down('sm')]: {
      padding: "10px",
    }
  },
  containerBody: {
    width: '100%',
    padding: "20px 40px 40px",
    minHeight: '500px',
    backgroundColor: theme.palette.primary.white,
    borderRadius: '3px',
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    }
  },
  title: {
    width: '100%',
    textAlign: 'center',
    fontSize: '40px',
    fontWeight: '600',
    margin: 0,
    color: theme.palette.primary.black,
  },
  containerButtons: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row !important',
    gap: '10px'
  },
  btnEdit: {
    backgroundColor: "transparent",
    color: theme.palette.secondary.black,
    boxShadow: "none",
    '&.Mui-disabled': {backgroundColor: "transparent", color: theme.palette.secondary.lightGray,},
    '&:hover': {
      backgroundColor: theme.cards.iconBackground,
      boxShadow: "none",
    },
  },
  btnActive: {
    color: theme.palette.secondary.black,
    fontSize: "2rem"
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'start',
    margin: '0px',
    padding: 0,
    gap: '10px',
    width: { md: '320px', xs: '100%' },
    color: theme.palette.secondary.black,
  },
  checkboxCustom: {
    margin: '0px 0px 0px 5px',
    color: theme.palette.secondary.black,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  switch: {
    padding: 1,
    '& .MuiSwitch-switchBase': {
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: theme.palette.primary.white,
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1.5,
        }
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.primary.main,
      opacity: 0.5,
    },
  },
});
